import i18next from 'i18next';
import { AGREEMENT_TYPE } from 'services/templates/agreement-template/types';
import {
  IContractTemplateTreeItemForm,
  IDistributionType,
  TEMPLATE_TYPE,
} from 'services/templates/types';

export const distributionTemplateInitialValues = (
  type: IDistributionType, 
  children?: IContractTemplateTreeItemForm[],
): IContractTemplateTreeItemForm[] => [
  {
    id: '0',
    type: TEMPLATE_TYPE.contract,
    content: i18next.t(`contract-template.${TEMPLATE_TYPE[type]}.contract-title`),
    disabledCollapse: true,
    disabledSelection: true,
    disabledRemove: true,
    disabledMoreButton: true,
    disabled: true,
    disabledInput: true,
    children: children ?? [
      {
        id: '1',
        type: type,
        autoFocus: true,
        disabledCollapse: true,
        disabledRemove: true,
        disabledSelection: true,
        children: [
          {
            type: TEMPLATE_TYPE.agreement,
            children: [],
            content: {
              type: AGREEMENT_TYPE.defaultShare,
              selectAgreementTemplate: null,
              textAgreementTemplate: null,
              distributionTemplateShares: {
                id: 'default-share-agreement',
                name: i18next.t(
                  `contract-template.${TEMPLATE_TYPE[type]}.default-share`
                ),
              },
            },
            id: 'default-share',
          },
        ],
        content: '',
      },
    ],
  },
];
